export const ROBUSTNESS_LEVEL = {
  SW_SECURE_CRYPTO: 'SW_SECURE_CRYPTO',
  SW_SECURE_DECODE:'SW_SECURE_DECODE',
  HW_SECURE_CRYPTO: 'HW_SECURE_CRYPTO',
  HW_SECURE_DECODE: 'HW_SECURE_DECODE',
  HW_SECURE_ALL: 'HW_SECURE_ALL',
};

export function isRudeTimestamp(value) {
  var tsYear = new Date(Number(value)).getFullYear();
  return tsYear >= (new Date().getFullYear() - 1);
}

export function isHasSrc(video) {
  return (
    Boolean(video.src) ||
    Array.from(video.children).some(
      (source) => source instanceof HTMLSourceElement && Boolean(source.src)
    )
  );
}

export function resetSrc(video) {
  video.src = "";
  Array.from(video.children).forEach((source) => {
    if (source instanceof HTMLSourceElement) {
      video.removeChild(source);
    }
  });
}

export async function checkRobustness() {
  async function check(robustness) {
    const config = [
      {
        initDataTypes: [ 'cenc' ],
        videoCapabilities: [
          {
            contentType: 'video/mp4; codecs="avc1.640028"', // High Profile AVC (FullHD)
            robustness: robustness,
          },
        ],
      },
    ];

    try {
      const ksa = await navigator.requestMediaKeySystemAccess('com.widevine.alpha', config);
      await ksa.createMediaKeys();
      return { result: true };
    } catch (e) {
      return { result: false, error: e.message };
    }
  }

  const levels = [
    ROBUSTNESS_LEVEL.SW_SECURE_CRYPTO,
    ROBUSTNESS_LEVEL.SW_SECURE_DECODE,
    ROBUSTNESS_LEVEL.HW_SECURE_CRYPTO,
    ROBUSTNESS_LEVEL.HW_SECURE_DECODE,
    ROBUSTNESS_LEVEL.HW_SECURE_ALL,
  ];

  let supportedRobustness;

  for (const robustness of levels) {
    const {
      result,
      // error,
    } = await check(robustness);
    // console.log(
    //   robustness,
    //   `${result ? '✅ Supported' : `❌ Not supported: ${error}`}`
    // );

    if (result) {
      supportedRobustness = robustness;
    }
  }

  return supportedRobustness;
}
